<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('dictionary.rateset')"
    icon="res-billrate"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :rateSetId="detailData.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :ratesetColumns="columns"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Rate from '@Bill/views/rate/components/List'
import Bindings from './Bindings'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillRateSetSidePage',
  components: {
    Rate,
    Bindings,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      listId: 'BillRateSetList',
    }
  },
  computed: {
    detailTabs () {
      const ret = [{ key: 'rate', label: this.$t('bill.rate.title.rate') }]
      if (this.detailData.id !== 'default') {
        ret.push({ key: 'bindings', label: this.$t('bill.budget_scope_label') })
      }
      return ret
    },
  },
}
</script>
